import { render, staticRenderFns } from "./ChainEditDialog.vue?vue&type=template&id=3ad4b0db&scoped=true"
import script from "./ChainEditDialog.vue?vue&type=script&lang=js"
export * from "./ChainEditDialog.vue?vue&type=script&lang=js"
import style0 from "./ChainEditDialog.vue?vue&type=style&index=0&id=3ad4b0db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad4b0db",
  null
  
)

export default component.exports